import { memoize } from '@exodus/basic-utils';
import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector } from 'reselect';
const selectorFactory = (createAssetRateSelector) => memoize((assetName) => createSelector(createAssetRateSelector(assetName), (rate) => rate?.price));
const createAssetPriceSelector = defineSelectorFactory({
    id: 'assetPrice',
    selectorFactory,
    dependencies: [
        //
        { selector: 'assetRate' },
    ],
});
export default createAssetPriceSelector;
